var _rect, _rect2, _rect3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagBrazil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 6",
    width: 21,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#ff671f",
    width: 9,
    height: 2,
    id: "rect2",
    x: 0,
    y: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: 9,
    height: 2,
    id: "rect4",
    x: 0,
    y: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#046a38",
    width: 9,
    height: 2,
    id: "rect6",
    x: 0,
    y: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wheel8",
    transform: "matrix(0.00391304,0,0,0.00391304,3.52174,2.02174)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 215,
    fill: "none",
    stroke: "#06038d",
    strokeWidth: 30,
    id: "circle1098"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(7.5,250,250)",
    id: "circle1100"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(22.5,250,250)",
    id: "circle1102"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(37.5,250,250)",
    id: "circle1104"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(52.5,250,250)",
    id: "circle1106"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(67.5,250,250)",
    id: "circle1108"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(82.5,250,250)",
    id: "circle1110"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(97.5,250,250)",
    id: "circle1112"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(112.5,250,250)",
    id: "circle1114"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(127.5,250,250)",
    id: "circle1116"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(142.5,250,250)",
    id: "circle1118"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(157.5,250,250)",
    id: "circle1120"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(172.5,250,250)",
    id: "circle1122"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-172.5,250,250)",
    id: "circle1124"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-157.5,250,250)",
    id: "circle1126"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-142.5,250,250)",
    id: "circle1128"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-127.5,250,250)",
    id: "circle1130"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-112.5,250,250)",
    id: "circle1132"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-97.5,250,250)",
    id: "circle1134"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-82.5,250,250)",
    id: "circle1136"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-67.5,250,250)",
    id: "circle1138"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-52.5,250,250)",
    id: "circle1140"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-37.5,250,250)",
    id: "circle1142"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-22.5,250,250)",
    id: "circle1144"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 250,
    r: 10,
    fill: "#06038d",
    transform: "rotate(-7.5,250,250)",
    id: "circle1146"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1150"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 250,230 243.028,170.304 250,40 l 6.972,130.304 z m 5.176,0.681 8.716,-59.466 40.46,-124.06 -26.99,127.67 z M 260,232.68 283.81,177.495 355,68.135 295.886,184.468 Z m 4.142,3.178 37.281,-47.142 97.07,-87.208 -87.21,97.069 z M 267.32,240 315.532,204.114 431.865,145 322.505,216.19 Z m 1.999,4.824 55.856,-22.186 127.67,-26.99 -124.06,40.46 z M 270,250 329.696,243.028 460,250 329.696,256.972 Z m -0.681,5.176 59.466,8.716 124.06,40.46 -127.67,-26.99 z M 267.32,260 322.505,283.81 431.865,355 315.532,295.886 Z m -3.178,4.142 47.142,37.281 87.208,97.07 -97.069,-87.21 z M 260,267.32 295.886,315.532 355,431.865 283.81,322.505 Z m -4.824,1.999 22.186,55.856 26.99,127.67 -40.46,-124.06 z M 250,270 256.972,329.696 250,460 243.028,329.696 Z m -5.176,-0.681 -8.716,59.466 -40.46,124.06 26.99,-127.67 z M 240,267.32 216.19,322.505 145,431.865 204.114,315.532 Z m -4.142,-3.178 -37.281,47.142 -97.07,87.208 87.21,-97.069 z M 232.68,260 184.468,295.886 68.135,355 177.495,283.81 Z m -1.999,-4.824 -55.856,22.186 -127.67,26.99 124.06,-40.46 z M 230,250 170.304,256.972 40,250 170.304,243.028 Z m 0.681,-5.176 -59.466,-8.716 -124.06,-40.46 127.67,26.99 z M 232.68,240 177.495,216.19 68.135,145 184.468,204.114 Z m 3.178,-4.142 -47.142,-37.281 -87.208,-97.07 97.069,87.21 z M 240,232.68 204.114,184.468 145,68.135 l 71.19,109.36 z m 4.824,-1.999 -22.186,-55.856 -26.99,-127.67 40.46,124.06 z",
    fill: "#06038d",
    id: "path1148"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 40,
    fill: "#06038d",
    id: "circle1152"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrazil);
export default __webpack_public_path__ + "static/media/Flag-Brazil.c4fa11bbbda929842f2ab8cd7834d8e8.svg";
export { ForwardRef as ReactComponent };